import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../lib/api-client';

/**
 * useRegistry Hook (Simplified)
 * 
 * Fetches high-level Agent Packages and available Providers.
 */
export function useRegistry() {
  const [data, setData] = useState({
    packages: [],
    providers: [],
    loading: true,
    error: null
  });

  const { getAccessToken } = useAuth();

  const fetchRegistry = useCallback(async () => {
    try {
      const token = getAccessToken();
      const res = await fetch(`${API_BASE}/registry`, {
        headers: {
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }
      });
      if (!res.ok) throw new Error('Failed to fetch registry');
      
      const registry = await res.json();
      setData({
        packages: registry.packages || [],
        providers: registry.providers || [],
        loading: false,
        error: null
      });
    } catch (err) {
      console.error('[useRegistry] Error:', err);
      setData(prev => ({ ...prev, loading: false, error: err.message }));
    }
  }, [getAccessToken]);

  useEffect(() => {
    fetchRegistry();
  }, [fetchRegistry]);

  return {
    ...data,
    refresh: fetchRegistry
  };
}